export function isGeometryNode(node) {
    return node !== undefined && node !== null && node.isGeometryNode;
}
export function isTreeNode(node) {
    return node !== undefined && node !== null && node.isTreeNode;
}
